import { createContext } from 'react';

export const FocusOnContext = createContext(false);
